<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Veículos do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(this.idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>

        <v-flex>
          <br />
        </v-flex>
        <v-flex> QTD. ÍTENS EXCLUSÃO </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-btn
            v-show="mostrarBotaoCorrigir()"
            color="error"
            round
            dark
            @click="corrigirItens()"
            >CORRIGIR ITENS: {{ selected.length }}
          </v-btn>

          <v-btn
            color="error"
            :disabled="selected.length === 0 || selecaoBloqueada"
            round
            @click="excluirItem(selected)"
          >
            EXCLUIR ÍTENS: {{ selected.length }}
          </v-btn>
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="veiculoList"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :select-all="!camposDisabled && !corretorParceiroBloquearAcoes"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled && !corretorParceiroBloquearAcoes"
                :active="props.selected"
                :class="{ 'removido-endosso': props.item.itemEndossoRemovido }"
                :style="
                  props.item.itemEndossoRemovido ||
                  itemRemovidoList.includes(props.item.item)
                    ? { color: '#fff', backgroundColor: '#ffbdb6' }
                    : { color: '#757575' }
                "
                @click="!selecaoBloqueada && (props.selected = !props.selected)"
              >
                <v-checkbox
                  class="checkbox"
                  :class="{ 'checkbox-removido': props.item.itemEndossoRemovido }"
                  color="primary"
                  :input-value="props.selected"
                  primary
                  hide-details
                  :disabled="camposDisabled || selecaoBloqueada"
                ></v-checkbox>
              </td>
              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[
                  'click',
                  ...(atributos.class || []),
                  {
                    'removido-endosso':
                      props.item.itemEndossoRemovido ||
                      itemRemovidoList.includes(props.item.item)
                  }
                ]"
                :style="
                  props.item.itemEndossoRemovido ||
                  itemRemovidoList.includes(props.item.item)
                    ? { color: '#fff', backgroundColor: '#ffbdb6' }
                    : { color: '#757575' }
                "
              >
                {{ texto }}
              </td>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-flex>
        <v-btn class="button-custom" type="submit" @click="proximo" flat>
          Próximo
        </v-btn>
      </v-flex>
    </v-layout>
      <v-dialog persistent v-model="showSucesso" max-width="500">
      <ModalAvisoExclusaoCorretor
        :visible="showAviso"
        @close="showAviso = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalEndossos from "../frota/ModalEndosso.vue";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";
import tipoEndossoEnum from "@/helpers/tipo-endosso-enum.js";
import ModalAvisoExclusaoCorretor from "./ModalAvisoExclusaoCorretor.vue";

export default {
  name: "GridEndossoVeiculoExclusaoCorretor",
  components: {
    ModalEndossos,
    ModalAvisoExclusaoCorretor
  },
  data() {
    return {
      showAviso: false,
      selecaoBloqueada: false,
      disableExcluir: false,
      listaApolice: [],
      listaRemovidosRascunho: [],
      itemRemovidoList: [],
      listaRascunho: [],
      idRascunhoEndosso: null,
      loading: true,
      apagarIten: [],
      idTipoEndosso: null,
      veiculoList: [],
      camposDisabled: false,
      selected: [],
      quantItens: null,
      diasVigencia: null,
      idApolice: null,
      idStatusCorretorReserva: null,
      filtrarErros: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      dialogConfirmacao: false,
      idStatusEndosso: null,
      corretorParceiroBloquearAcoes: false,
      numeroRevisao: null,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: null,
        descending: false,
        totalItems: 0
      },
      regras: {
        notNull: [v => !!v || "Você não pode deixar este campo em branco"]
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        }
      },
      resultados: {
        totalPremio: null
      },
      chassis: [],
      chassiQtdPassageiros: [],
      veiculosList: [],
      codigoSistemaRastreamentoList: [],

      lista: [],
      endosso: {},
      headers: [
        { text: "ITEM", value: "item" },
        {
          text: "PLACA",
          align: "left",
          value: "placa"
        },
        { text: "CHASSI", value: "chassi" },
        { text: "FIPE", value: "fipe", style: "width: 100px" },
        { text: "MARCA", value: "marca" },
        { text: "MODELO ", value: "modelo" },
        { text: "TIPO VEÍCULO", value: "tipoVeiculo" },
        { text: "CAT. VEÍCULO", value: "catVeiculo" },
        { text: "ANO FAB.", value: "anoFab" },
        { text: "ANO MOD.", value: "anoMod" },
        { text: "UF PERNOITE", value: "ufPernoite" },
        { text: "USO DO VEÍCULO", value: "usoDoVeiculo" },
        {
          text: "PROPRIEDADE (REGISTRO DO CRLV)",
          value: "propriedadeRegistroDoCrlv"
        },
        { text: "PROPRIETÁRIO", value: "proprietario" },
        { text: "CPF/CNPJ", value: "cpfCnpj" },
        { text: "NOME SOCIAL", value: "nomeSocial" },
        { text: "CHASSI REMARCADO", value: "chassiRemarcado" },
        { text: "ZERO KM", value: "zeroKm" },
        { text: "SAÍDA CONCESSIONÁRIA", value: "saidaDaConcessionaria" },
        { text: "QUANT PASSAGEIROS", value: "quantPassageiros" },
        { text: "DISPOSITIVO DE SEGURANÇA", value: "codigoSistemaRastreamento" }
      ]
    };
  },
  watch: {
    'pagination.page': 'buscarVeiculos',
    'pagination.rowsPerPage': 'buscarVeiculos'
  },
  mounted() {
    this.corretorParceiroBloquearAcoes = this.$route.query.corretorParceiro === 'true';
    this.idStatusEndosso = parseInt(this.$route.query.idStatusEndosso);
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.idTipoEndosso = this.$route.query.idTipoEndosso;
    this.numeroRevisao = parseInt(this.$route.query.numeroRevisao);
    this.idApolice = parseInt(this.$route.query.id);
    this.idStatusCorretorReserva = this.$route.query.idStatusCorretorReserva
      ? this.$route.query.idStatusCorretorReserva
      : null;
    if (this.idRascunhoEndosso == undefined) {
      this.veiculoList = this.$store.getters[
        "formEndosso/cloneConteudoPlanilha"
      ];
    }
    if (this.corretorParceiroBloquearAcoes) {
      this.buscarVeiculos();
    } else {
      this.buscarVeiculosParaExclusao(this.numeroRevisao);
    }
  },
  methods: {
    async buscarNumPassageiro(chassis) {
      const chassiModel = {
        chassis: chassis
      };
      var response = await axios.post(
        `${process.env.URL_APOLICEMS}/v1/buscarNumeroPassageiro/`,
        chassiModel,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.chassiQtdPassageiros = response.data;
    },

    visualizarEndosso(idEndosso, rascunho) {
      if (rascunho) {
        return "RascunhoEndosso";
      } else if (
        idEndosso &&
        (this.idStatusEndosso == statusEndossoEnum.statusEndosso.SALVO || this.idStatusEndosso == statusEndossoEnum.statusEndosso.PENDENTE) &&
        this.idTipoEndosso != tipoEndossoEnum.tipoEndosso.CANCELAMENTO
      ) {
        return "EndossoSalvo";
      } else {
        return "Endosso";
      }
    },

    async buscarEndosso(idEndosso, rascunho) {
      const response = await axios.get(
        `${process.env.URL_ENDOSSOMS}/v1/visualizar${this.visualizarEndosso(
          idEndosso,
          rascunho
        )}/${idEndosso}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.endosso = response.data;
      this.listaRemovidosRascunho = this.endosso.itensRemovidosList	;
      this.dateInicio = this.endosso.dateInicio;

      if (this.listaRemovidosRascunho.length > 0) {
        for (var itemRemovido of this.listaRemovidosRascunho) {
          for (var item of this.veiculoList) {
            if (item.item === itemRemovido) {
              this.itemRemovidoList.push(item.item);
              this.veiculoList.splice(this.veiculoList.indexOf(item), 1);
            }
          }
        }
      }
      for (var itemModificado of this.endosso.itemModificadoList) {
        for (var itemApolice of this.veiculoList) {
          var teste = Object.fromEntries(
            Object.entries(itemModificado).filter(
              ([k, v]) => [k].includes(k) && v !== null && v !== undefined
            )
          );
          if (teste.item === itemApolice.item) {
            Object.assign(itemApolice, teste);
            this.veiculoList.sort();
          }
        }
      }

    },

    storageItemExclusao() {
      var veiculoList = {
        dados: this.itemRemovidoList
      };
      var veiculoRestanteList = {
        dados: this.veiculoList
      };
      this.$store.commit("formEndosso/dadosItemExclusao", veiculoList);
      this.$store.commit(
        "formEndosso/dadosItensRestantes",
        veiculoRestanteList
      );
    },
    excluirItem(itens) {
      const selecionados = new Set(this.selected.map(e => e.item));

      this.itemRemovidoList = [
        ...new Set([...this.itemRemovidoList, ...selecionados])
      ];

      const marcarComoRemovido = lista => {
        lista.forEach(e => {
          if (selecionados.has(e.item)) {
            this.$set(e, 'itemEndossoRemovido', true);
          }
        });
      };

      if (this.idRascunhoEndosso) {
        marcarComoRemovido(this.listaApolice);
      } else {
        marcarComoRemovido(this.veiculoList);
      }

      this.selected = this.selected.filter(e => e.itemEndossoRemovido);

      this.selecaoBloqueada = true;

      this.showAviso = true;
    },

    corrigirItens() {
      const limparItens = lista => {
        lista.forEach(e => {
          if (e.itemEndossoRemovido) {
            this.$set(e, 'itemEndossoRemovido', false);
          }
        });
      };

      if (this.idRascunhoEndosso) {
        limparItens(this.listaApolice);
      } else {
        limparItens(this.veiculoList);
      }

      this.itemRemovidoList = [];
      this.selected = [];

      this.selecaoBloqueada = false;
    },

    mostrarBotaoCorrigir() {
      return this.selecaoBloqueada;
    },


    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "RESTITUIÇÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
    },
    async buscarVeiculosParaExclusao() {
      if (this.idStatusEndosso !== statusEndossoEnum.statusEndosso.SALVO && this.idRascunhoEndosso == undefined) {
        this.buscarVeiculos();
      }
    },

    async buscarVeiculos() {
      this.loading = true;
      this.$store.commit("startLoading");
      await axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/listarVeiculos/${this.idApolice}` +
            `/?page=${this.pagination.page - 1}&size=${
              this.pagination.rowsPerPage
            }&ignore=${this.itemRemovidoList.join(",")}&idTipoEndosso=${this.idTipoEndosso}${this.numeroRevisao ? `&numeroRevisaoEndosso=${this.numeroRevisao}` : ''}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if(this.idStatusEndosso == statusEndossoEnum.statusEndosso.ENDOSSO_APROVADO || this.idStatusEndosso == statusEndossoEnum.statusEndosso.EMITIDA) {
            this.veiculoList = this.veiculoList.map(item => {
              return Object.entries(item).reduce((acc, [key, valor]) => {
                acc[key] =
                  valor &&
                  typeof valor === "object" &&
                  !Array.isArray(valor)
                    ? (valor.titulo ? valor.titulo : null)
                    : valor;

                return acc;
              }, {});
            });
          } else {
            if(this.idStatusEndosso == statusEndossoEnum.statusEndosso.ENDOSSO_REPROVADO) {
              this.veiculoList = response.data.content
                .filter(
                  item =>
                    this.itemRemovidoList.includes(item.item) ||
                    item.itemEndossoRemovido === true
                )
                .map(item => ({
                  ...item,
                  itemEndossoRemovido: false
                }));
            } else {
              this.veiculoList = response.data.content;
            }
            if (this.corretorParceiroBloquearAcoes) {
              this.buscarVeiculosItensModificados();
              if(this.itemRemovidoList) {
                const itensRemovidos = new Set(this.itemRemovidoList);
                this.veiculoList = this.veiculoList.map(veiculo => {
                  if (itensRemovidos.has(veiculo.item)) {
                    return {
                      ...veiculo,
                      itemEndossoRemovido: true
                    };
                  }
                  return veiculo;
                });
              }
            }

            this.pagination.totalItems = response.data.totalElements;
            if (this.idRascunhoEndosso) {
              this.buscarEndosso(
                this.idRascunhoEndosso,
                this.idRascunhoEndosso
              );
            }
          }
          for (var chassi of this.veiculoList) {
            this.chassis.push(chassi.chassi);
          }
          this.buscarNumPassageiro(this.chassis);
          this.$store.commit("endLoading");
        })
        .catch(err => {
          this.$store.commit("endLoading");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async buscarVeiculosItensModificados() {
      await axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarVeiculosItensModificados/${this.idApolice}/${this.numeroRevisao}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.itemRemovidoList = response.data;
        })
        .catch(err => {
          this.$store.commit("endLoading");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    colunas(item) {
      return [
        [this.formatarNumeroItem(item.item), { class: "pa-4" }],
        [item.placa, {}],
        [item.chassi, { class: "pa-4" }],
        [item.fipe, { class: "pa-4" }],
        [item.marca, { class: "pa-4" }],
        [item.modelo, {}],
        [item.tipoVeiculo, {}],
        [item.catVeiculo, {}],
        [item.anoFab, {}],
        [item.anoMod, {}],
        [item.ufPernoite, {}],
        [item.usoDoVeiculo, {}],
        [item.propriedadeRegistroDoCrlv, {}],
        [item.proprietario, {}],
        [item.cpfCnpj, {}],
        [item.nomeSocial, {}],
        [this.traduzValor(item.chassiRemarcado), {}],
        [this.traduzValor(item.zeroKm), {}],
        [item.saidaDaConcessionaria, {}],
        [this.buscarQuantPassageiro(item.chassi), {}],
        [this.traduzValor(item.codigoSistemaRastreamento), {}]
      ];
    },
    buscarQuantPassageiro(chassi) {
      for (var quant of this.chassiQtdPassageiros) {
        if (quant.nrChassi === chassi) {
          return quant.nrQtdPax;
        }
      }
    },
    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    contarData() {
      const dataAtual = new Date();
      const dataFimVigencia = new Date(this.endosso.dataFim);
      const contagem = dataFimVigencia.getTime() - dataAtual.getTime();
      this.diasVigencia = Math.floor(contagem / 8.64e7);
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },
    formatStatusEndosso(status) {
      if (status == 1) return "SALVO";
      if (status == 2) return "EMITIDA";
      if (status == 3) return "AG. ENDOSSO";
      if (status == 4) return "ENDOSSO APROVADO";
      if (status == 5) return "ENDOSSO REPROVADO";
    },
    formatTipoEndosso(tipo) {
      if (tipo == 1) return "COBRANÇA";
      if (tipo == 2) return "RESTITUIÇÃO";
      if (tipo == 3) return "SEM MOVIMENTAÇÃO";
      if (tipo == 4) return "CANCELAMENTO";
    },

    somaNumeros(numeros) {
      let soma = 0;
      for (let i = 0; i < numeros.length; i++) {
        soma += numeros[i].itemExcInc;
      }
      return soma;
    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric"
        });
      }
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    deletarItens() {
      const selecionados = this.selected.map(e => e.item);
      this.veiculoList = this.veiculoList.filter(
        e => !selecionados.includes(e.item)
      );
    },

    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },

    voltar: function() {
      this.$router.push(
        `/corretor/InfoEndosso?id=${
          this.idApolice
        }${
          this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
        }&idTipoEndosso=${
          this.idTipoEndosso
        }${
          this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
        }${
          this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
        }${
          this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
        }`
      );
    },
    proximo() {
      this.storageItemExclusao();

      this.$router.push(
        `/corretor/gridCoberturasExclusaoCorretor?id=${
          this.idApolice
        }${
          this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
        }&idTipoEndosso=${
          this.idTipoEndosso
        }${
          this.idStatusCorretorReserva ? `&idStatusCorretorReserva=${this.idStatusCorretorReserva}` : ''
        }${
          this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
        }${
          this.$route.query.corretorParceiro === 'true' ? `&corretorParceiro=true` : ''
        }`
      );
    },

    formatarNumeroCotacao(item) {
      if (item != null) {
        const numero = `000000${item}`;
        return numero.slice(numero.length - 6);
      }
    }
  }
};
</script>

<style>
.background {
  background-color: white;
}

.table-width > div > div > table {
  width: 3000px;
}

.item-color > div > a {
  color: #757575 !important;
}

.activeError {
  border: 1px solid red;
  color: red !important;
}

.button-permanecer {
  background: #00456e;
  color: white !important;
}

.text-permanecer {
  font-weight: bold;
  color: #757575 !important;
}
.errorTaxa {
  color: red !important;
  font-weight: bold;
}
.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}
.button-custom:hover {
  background-color: #063f57;
}

.disabled,
.v-btn.button-custom:disabled {
  cursor: default;
  background-color: #063f57;
  color: #aaaaaa !important;
}

.disabled:hover {
  background-color: #063f57;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/GridEndossoVeiculoExclusaoCorretor.vue